"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var useWinnerCard = function (_a) {
    var slug = _a.slug, gameCardPlaceholder = _a.gameCardPlaceholder;
    var _b = (0, react_1.useState)(false), hovered = _b[0], setHovered = _b[1];
    var _c = (0, react_1.useState)(gameCardPlaceholder), imageSrc = _c[0], setImageSrc = _c[1];
    var t = (0, next_intl_1.useTranslations)();
    var isSignedIn = (0, swr_hooks_1.useIsAuthorized)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var push = (0, navigation_1.useRouter)().push;
    var handleClickOnGame = (0, react_1.useCallback)(function (fun) {
        if (fun === void 0) { fun = false; }
        if (isSignedIn) {
            push("/game/".concat(slug).concat(fun ? '?demo=true' : ''));
        }
        else {
            openSignUp();
        }
    }, [slug, isSignedIn, openSignUp, push]);
    var gameInfoLink = (0, apps_shared_1.useModalLink)("".concat(apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL).concat(slug));
    var openGameInfo = (0, react_1.useCallback)(function () { return push(gameInfoLink); }, [gameInfoLink, push]);
    return {
        t: t,
        hovered: hovered,
        imageSrc: imageSrc,
        setImageSrc: setImageSrc,
        openGameInfo: openGameInfo,
        setHovered: setHovered,
        handleClickOnGame: handleClickOnGame,
    };
};
exports.default = useWinnerCard;
